import React from 'react';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import { track } from '../actions/TrackActions';

// Class-based Error Boundary
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, key: 0 };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    if (this.props.sentryCapture) {
      // Capture the error with Sentry including a custom message
      Sentry.captureException(
        new Error(
          `${this.props.name || 'ErrorBoundary'} error: ${error.message}`
        )
      );
    }

    if (this.props.token) {
      // Log event to analysis-service
      track(`ErrorBoundary:${this.props.name || 'ErrorBoundary'}`, {
        message: error.message,
        ...errorInfo,
      });
    }

    // Reset error state after the current stack finishes, causing a re-mount of children.
    setTimeout(() => {
      this.setState((prevState) => ({
        error: null,
        key: prevState.key + 1,
      }));
    }, 0);
  }

  render() {
    // Remount children on error by using the key prop
    return (
      <React.Fragment key={this.state.key}>
        {this.props.children}
      </React.Fragment>
    );
  }
}

// Functional wrapper that uses useSelector to access Redux state
const ErrorBoundaryWrapper = ({ children, name, sentryCapture = false }) => {
  const token = useSelector((state) => state.user.token);
  return (
    <ErrorBoundary name={name} sentryCapture={sentryCapture} token={token}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryWrapper;
